SessionController.$inject = ['$scope', '$timeout', 'ShellService']

export default function SessionController($scope, $timeout, ShellService) {
  var vm = this

  function toggleFullscreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen()
    } else {
      document.documentElement.requestFullscreen()
    }
  }

  function updateFullscreenIcon() {
    if (document.fullscreenElement) {
      vm.fullscreenStatus = 'on'
      $scope.$apply()
    } else {
      vm.fullscreenStatus = 'off'
      $scope.$apply()
    }
  }

  function selectGridSquareIndex(index) {
    if (index !== 0) {
      vm.selectedIndex.push(index)
    }

    if (vm.selectedIndex.length === 6) {
      vm.sessionComponent++

      $timeout(function() {
        function formatTime(timeInSeconds) {
          const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8)
        
          return {
            minutes: result.substr(3, 2),
            seconds: result.substr(6, 2)
          }
        }

        function initVideo() {
          const time = formatTime(Math.round(video.duration))
          $scope.timeElapsed = `${time.minutes}:${time.seconds}`
          $scope.$apply() // Must call this in order to bind updated model value to the view
        }

        function updateTimeElapsed() {
          const time = formatTime(Math.round(video.duration - video.currentTime))
          $scope.timeElapsed = `${time.minutes}:${time.seconds}`
          $scope.$apply()
        }

        const video = angular.element('video')[1]
        video.onloadedmetadata = () => initVideo()
        video.play()
        video.ontimeupdate = () => updateTimeElapsed()
        $scope.controlsOn = true
        $scope.status = 'playing'
        $scope.playOn = false
        video.onended = function() {
          swal({
            title: 'Good job!',
            text: '',
            icon: 'success',
            buttons: {
              confirm: {
                text: 'Next',
                className: display === 'small' ? 'waves-effect waves-light btn brand-primary' : 'waves-effect waves-light btn-large brand-primary'
              }
            },
          }).then(isConfirmed => {
            if (isConfirmed) {
              vm.sessionComponent++
              $scope.controlsOn = false
              $scope.$apply()
            }
          })
        }
      }, 10)
    }
  }

  function selectGridSquare(index) {
    if (index !== 0) {
      vm.selected.push(index)
    }

    if (vm.selected.length === 6) {
      swal({
        title: 'Good job!',
        text: '',
        icon: 'success',
        buttons: {
          confirm: {
            text: 'Next',
            className: display === 'small' ? 'waves-effect waves-light btn brand-primary' : 'waves-effect waves-light btn-large brand-primary'
          }
        },
      }).then(isConfirmed => {
        if (isConfirmed) {
          vm.sessionComponent++
          $scope.$apply()
          initialiseDarts()
        }
      })
    }
  }

  function initialiseDarts() {
    $timeout(function() {
      vm.dartFamilyTopPos = (dartboard.height - (dart.height / 2))
      vm.dartFamilyLeftPos = dartboard.offsetLeft / 1.5
      vm.dartEducationTopPos = (dartboard.height - (dart.height / 2))
      vm.dartEducationLeftPos = dartboard.offsetLeft / 1.5 + 30
      vm.dartFriendsTopPos = (dartboard.height - (dart.height / 2))
      vm.dartFriendsLeftPos = dartboard.offsetLeft / 1.5 + 60
      vm.dartWorkTopPos = (dartboard.height - (dart.height / 2))
      vm.dartWorkLeftPos = dartboard.offsetLeft / 1.5 + 90
      vm.dartHealthTopPos = (dartboard.height - (dart.height / 2))
      vm.dartHealthLeftPos = dartboard.offsetLeft / 1.5 + 120
      vm.dartRelationshipsTopPos = (dartboard.height - (dart.height / 2))
      vm.dartRelationshipsLeftPos = dartboard.offsetLeft / 1.5 + 150

      // vm.areaCoords = {
      //   x: dartboard.width / 2,
      //   y: dartboard.height / 2,
      //   r: dartboard.width / 2.68
      // }
      vm.dartActive = 'family'
      vm.areaCoords = {
        center: {
          x: dartboard.width / 2,
          y: dartboard.height / 2
        },
        one: {
          x: dartboard.width / 2,
          y: dartboard.height - (dartboard.height * 0.1)
        },
        two: {
          x: dartboard.width - (dartboard.width * 0.15),
          y: dartboard.height - (dartboard.height * 0.3)
        }
      }
    }, 10)
  }

  function placeDart(event) {
    if (counter === 1) {
      vm.dartFamily = require('../../assets/dart-flight.svg')
      const dart = angular.element('#dart-family')[0]
      vm.dartFamilyTopPos = event.clientY - dart.height
      vm.dartFamilyLeftPos = event.clientX - dart.width
      counter++
      vm.dartActive = 'education'
      vm.areaCoords = {
        center: {
          x: dartboard.width / 2,
          y: dartboard.height / 2
        },
        one: {
          x: dartboard.width - (dartboard.width * 0.15),
          y: dartboard.height - (dartboard.height * 0.3)
        },
        two: {
          x: dartboard.width - (dartboard.width * 0.15),
          y: dartboard.height - (dartboard.height * 0.7)
        }
      }
    } else if (counter === 2) {
      vm.dartEducation = require('../../assets/dart-flight.svg')
      const dart = angular.element('#dart-education')[0]
      vm.dartEducationTopPos = event.clientY - dart.height
      vm.dartEducationLeftPos = event.clientX - dart.width
      counter++
      vm.dartActive = 'friends'
      vm.areaCoords = {
        center: {
          x: dartboard.width / 2,
          y: dartboard.height / 2
        },
        one: {
          x: dartboard.width - (dartboard.width * 0.15),
          y: dartboard.height - (dartboard.height * 0.7)
        },
        two: {
          x: dartboard.width / 2,
          y: dartboard.height - (dartboard.height * 0.9)
        }
      }
    } else if (counter === 3) {
      vm.dartFriends = require('../../assets/dart-flight.svg')
      const dart = angular.element('#dart-friends')[0]
      vm.dartFriendsTopPos = event.clientY - dart.height
      vm.dartFriendsLeftPos = event.clientX - dart.width
      counter++
      vm.dartActive = 'work'
      vm.areaCoords = {
        center: {
          x: dartboard.width / 2,
          y: dartboard.height / 2
        },
        one: {
          x: dartboard.width / 2,
          y: dartboard.height - (dartboard.height * 0.9)
        },
        two: {
          x: dartboard.width - (dartboard.width * 0.85),
          y: dartboard.height - (dartboard.height * 0.7)
        }
      }
    } else if (counter === 4) {
      vm.dartWork = require('../../assets/dart-flight.svg')
      const dart = angular.element('#dart-work')[0]
      vm.dartWorkTopPos = event.clientY - dart.height
      vm.dartWorkLeftPos = event.clientX - dart.width
      counter++
      vm.dartActive = 'health'
      vm.areaCoords = {
        center: {
          x: dartboard.width / 2,
          y: dartboard.height / 2
        },
        one: {
          x: dartboard.width - (dartboard.width * 0.85),
          y: dartboard.height - (dartboard.height * 0.7)
        },
        two: {
          x: dartboard.width - (dartboard.width * 0.85),
          y: dartboard.height - (dartboard.height * 0.3)
        }
      }
    } else if (counter === 5) {
      vm.dartHealth = require('../../assets/dart-flight.svg')
      const dart = angular.element('#dart-health')[0]
      vm.dartHealthTopPos = event.clientY - dart.height
      vm.dartHealthLeftPos = event.clientX - dart.width
      counter++
      vm.dartActive = 'relationships'
      vm.areaCoords = {
        center: {
          x: dartboard.width / 2,
          y: dartboard.height / 2
        },
        one: {
          x: dartboard.width - (dartboard.width * 0.85),
          y: dartboard.height - (dartboard.height * 0.3)
        },
        two: {
          x: dartboard.width / 2,
          y: dartboard.height - (dartboard.height * 0.1)
        }
      }
    } else if (counter === 6) {
      vm.dartRelationships = require('../../assets/dart-flight.svg')
      const dart = angular.element('#dart-relationships')[0]
      vm.dartRelationshipsTopPos = event.clientY - dart.height
      vm.dartRelationshipsLeftPos = event.clientX - dart.width
      
      swal({
        title: 'Good job!',
        text: '',
        icon: 'success',
        buttons: {
          confirm: {
            text: 'Next',
            className: display === 'small' ? 'waves-effect waves-light btn brand-primary' : 'waves-effect waves-light btn-large brand-primary'
          }
        },
      }).then(isConfirmed => {
        if (isConfirmed) {
          vm.sessionComponent++
          $scope.$apply()
        }
      })
    }
  }

  const display = ShellService.display

  vm.fullscreenStatus = 'off'

  if (document.fullscreenEnabled) { // If fullscreen API supported
    vm.fullscreenOn = true // Allow fullscreen
  }

  vm.gridSquares = [
    '',
    'Travel',
    'Get an illness',
    'Be successful',
    'Cheat others',
    'Be honored',
    'Unemployment',
    'Inspire others',
    'Be honest',
    'Crushing debt',
    'Financial security',
    'Live with parents forever',
    'Change the world',
    'Go to prison',
    'Be creative',
    'Get dumped',
    'Lose keys and wallet daily',
    'Work hard',
    'Get rejected',
    'Be brave',
    'Never finish anything',
    'Love others',
    'Be reckless',
    'Persist',
    'Have integrity',
    'Hate your job',
    'Lead others',
    'Develop gambling problem',
    'Be strong and healthy',
    'Turn to a life of crime',
    'Be adventurous',
    'Take from others',
    'Be lazy',
    'Live free',
    'Fight with others non-stop',
    'Be kind to yourself and others',
    'Steal',
    'Always learning',
    'Financial ruin',
    'Help others',
    'Marriage or long-term partnered',
    'Embezzle money',
    'Fight for peace',
    'Become a scrooge',
    'Wisdom',
    'Addiction',
    'Protect the environment',
    'No job, ever!',
    'Avoid doing anything hard',
    'Experience beauty',
    'Compulsive lying',
    'To be loved',
    'Get fired',
    'Care for others',
    'Never trust anyone',
    'Seek truth',
    'Speak out against injustice',
    'Be mean',
    'Be someone’s hero or role model',
    'Be grumpy',
    'Be responsible',
    'Hold grudges forever',
    'Be authentic',
    'Judge others'
  ]

  const video = angular.element('video')[0]
  const dartboard = angular.element('.dartboard')[0]
  const dart = angular.element('.dart')[0]
  vm.dartFamily = require('../../assets/dart.svg')
  vm.dartEducation = require('../../assets/dart.svg')
  vm.dartFriends = require('../../assets/dart.svg')
  vm.dartWork = require('../../assets/dart.svg')
  vm.dartHealth = require('../../assets/dart.svg')
  vm.dartRelationships = require('../../assets/dart.svg')
  vm.sessionComponent = 1
  vm.selectedIndex = []
  vm.selected = []
  let counter = 1

  vm.toggleFullscreen = () => toggleFullscreen()
  document.onfullscreenchange = () => updateFullscreenIcon()
  vm.selectGridSquareIndex = index => selectGridSquareIndex(index)
  vm.selectGridSquare = index => selectGridSquare(index)
  vm.placeDart = event => placeDart(event)

  vm.showPrev = function() {
    vm.sessionComponent--
    $timeout(function() {
      if (!video.parentElement.classList.contains('ng-hide')) $scope.controlsOn = true
    }, 10)
  }
  vm.showNext = function() {
    vm.sessionComponent++
    video.pause()
    $scope.status = 'paused'
    $scope.playOn = true
    $timeout(function() {
      if (video.parentElement.classList.contains('ng-hide')) $scope.controlsOn = false
    }, 10)
    if (vm.sessionComponent === 3) {
      $timeout(function() {
        const video = angular.element('video')[1]
        video.play()
        $scope.status = 'playing'
        $scope.playOn = false
      }, 10)
    }
    if (vm.sessionComponent === 5) {
      initialiseDarts()
    }
  }
}